import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { GA } from '../../data/GA'
import { envUrls } from '../../data/objects/env'
import { countItems } from '../../utils/helpers'

export enum LoginState {
  LOADING,
  SIGNED_IN,
  SIGNED_OUT,
}

export interface UserState {
  loginState: LoginState
  name?: string
  id?: number
  authToken?: string
  intercomDataEvent?: any
  itemsCount?: number
}

function dataToUserState(req: any) {
  const { data } = req
  const newState: UserState = {
    loginState: LoginState.SIGNED_OUT,
  }
  if (data.userId) {
    GA.userData({
      id: data.userId,
      phone: data.phone,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
    })
    const preDeliveryItemsCount = countItems(data.items)
    const doneCount = data.items.filter((item: any) => item.state !== 'done').length
    newState.loginState = LoginState.SIGNED_IN
    newState.name = data.firstName
    newState.id = data.userId
    newState.itemsCount = preDeliveryItemsCount
    newState.intercomDataEvent = {
      event: 'contactDataEvent',
      contactId: data.userId,
      contactName: `${data.firstName} ${data.lastName}`,
      contactEmail: data.email,
      contactPhone: data.phone,
      itemsCount: data.items.length,
      postDeliveredItemsCount: data.items.length - preDeliveryItemsCount - doneCount,
      contactHashKey: data.contactHashKey,
      'User Account': `${envUrls.site}/backend/users/${data.userId}`,
      AccountManager: data.accountManagerName,
    }
  }
  return newState
}

// Define a service using a base URL and expected endpoints
export const UserApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({ baseUrl: envUrls.contentBE }),
  endpoints: (builder) => ({
    getUserState: builder.query<UserState, void>({
      query: () => `userInfo`,
      transformResponse: dataToUserState,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUserStateQuery } = UserApi
